import React, { useState } from "react";
import { CONSTANTS_STRINGS } from "src/constants";
import { useCheckoutDataContext } from "src/providers/SharedDataProvider";
import { DirectDebtPaymentMethodChangeFormData } from "src/schemas/DirectDebtFormSchema";
import { CheckoutHelper, CurrencyHelper } from "src/utils";
import BankAccountInfo from "./BankAccountInfo";
import EditAccountModal from "./EditAccountModal";
import InfoItem from "./InfoItem";

interface DetailCardProps {
  amount?: number;
  accountData: DirectDebtPaymentMethodChangeFormData | undefined;
  onUpdateAccountData?: (
    updatedData: DirectDebtPaymentMethodChangeFormData,
  ) => void;
  isPaymentMethodChange?: boolean;
}

const DetailCard: React.FC<DetailCardProps> = ({
  amount,
  accountData,
  onUpdateAccountData,
  isPaymentMethodChange = false,
}) => {
  const checkoutData = useCheckoutDataContext();
  const isLifeType = CheckoutHelper.isLifeType(checkoutData);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSave = (updatedData: DirectDebtPaymentMethodChangeFormData) => {
    if (onUpdateAccountData) {
      onUpdateAccountData(updatedData);
    }
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  if (!accountData) return null;

  const displayedAmount = isLifeType
    ? (accountData.installmentOption?.parcelAmount ?? amount)
    : amount;

  return (
    <article
      className="grid items-center gap-6"
      aria-label="Detalhes do débito direto"
    >
      <dl className="grid gap-6">
        <InfoItem
          label="Valor"
          value={CurrencyHelper.formatBRCurrency(displayedAmount ?? 0)}
        />

        {!isPaymentMethodChange && !isLifeType && (
          <InfoItem
            label={CONSTANTS_STRINGS.CREDIT_CARD_INSTALLMENTS}
            value={accountData.installmentOption?.label ?? "-"}
          />
        )}

        {!isPaymentMethodChange && (
          <InfoItem
            label={
              isLifeType
                ? CONSTANTS_STRINGS.DIRECT_DEBIT_BILLING_DAY_LIFE_LABEL
                : CONSTANTS_STRINGS.DIRECT_DEBIT_BILLING_DAY_LABEL
            }
            value={
              accountData.billingDay
                ? accountData.billingDay.split("-").reverse().join("/")
                : "-"
            }
          />
        )}
      </dl>

      <BankAccountInfo
        accountData={accountData}
        onEditClick={() => setIsModalOpen(true)}
      />

      <EditAccountModal
        isOpen={isModalOpen}
        accountData={accountData}
        onCancel={handleCancel}
        onSave={handleSave}
      />
    </article>
  );
};

export default DetailCard;
